import { axios } from '@Root/API'

export const getDataCreationPermissions = () => {
	return axios.get(`get-permissions/create`)
}
